var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-detail" } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("div", { staticClass: "detail-head" }, [
            _vm.otherVisitors.length > 1
              ? _c("div", { staticClass: "visitor-merge-bar" }, [
                  _c(
                    "span",
                    { staticClass: "visitor-merge-left" },
                    [
                      _c("span", { staticClass: "visitor-merge-title" }, [
                        _vm._v(
                          _vm._s(_vm.otherVisitors.length) +
                            " similar profiles found"
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.otherVisitors, function (otherVisitor, index) {
                        return _c(
                          "span",
                          {
                            staticClass: "visitor-merge-item",
                            class:
                              _vm.selectedMergeVisitorId === otherVisitor._id
                                ? "other-visitor-selected"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.getVisitorInfo(otherVisitor._id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.otherVisitors.length < 8
                                  ? "Profile #" + (index + 1)
                                  : "#" + (index + 1)
                              )
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "visitor-merge-right",
                      on: {
                        click: function ($event) {
                          return _vm.mergeVisitors()
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "22px", color: "black" },
                        },
                        [_vm._v("auto_fix_high")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "visitor-merge-name" }, [
                        _vm._v(
                          "Merge " +
                            _vm._s(_vm.otherVisitors.length) +
                            " profiles"
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "head-color" }),
            _vm._v(" "),
            _c("div", { staticClass: "header-wrapper" }, [
              _c(
                "span",
                { staticClass: "user-segment-avatar text-center" },
                [
                  _c(
                    "md-highlight-text",
                    {
                      staticClass: "text-center",
                      attrs: { "md-term": "term" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            !!_vm.visitor.fullname
                              ? _vm.visitor.fullname.substr(0, 1).toUpperCase()
                              : "V"
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "user-details" }, [
                _c(
                  "div",
                  { staticClass: "username-detail" },
                  [
                    _c("div", { staticClass: "user-name" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.visitor.fullname
                              ? _vm.visitor.fullname
                              : "Visitor"
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["visitor.view"].tr.name
                    )
                      ? _c(
                          "a-popover",
                          {
                            staticClass:
                              "visitor-popover story-menu-content px-3",
                            attrs: { placement: "bottom", trigger: "focus" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "delete-user",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "close-circle-o" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.checkPermission(
                                  _vm.PERMISSION_TYPES["visitor.delete"].tr.name
                                )
                                  ? _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.deleteUserVisible = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("visitor.deleteUser"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "ban-user",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "stop-o" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.visitorBanned &&
                                _vm.checkPermission(
                                  _vm.PERMISSION_TYPES["visitor.block"].tr.name
                                )
                                  ? _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.ban()
                                          },
                                        },
                                      },
                                      [_vm._v("Block User")]
                                    )
                                  : _vm.checkPermission(
                                      _vm.PERMISSION_TYPES["visitor.unblock"].tr
                                        .name
                                    )
                                  ? _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.unban()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    UnBlock User\n                                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isWABusiness()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "wa-business-chat",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c("a-icon", {
                                          staticClass: "px-1",
                                          attrs: { type: "play-circle" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.ban()
                                          },
                                        },
                                      },
                                      [_vm._v("Start Chat")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isWhatsappV1()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "wa-business-chat",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c("a-icon", {
                                          staticClass: "px-1",
                                          attrs: { type: "play-circle" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.ban()
                                          },
                                        },
                                      },
                                      [_vm._v("Start Chat")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isWhatsappV2()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "wa-business-chat",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c("a-icon", {
                                          staticClass: "px-1",
                                          attrs: { type: "play-circle" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.ban()
                                          },
                                        },
                                      },
                                      [_vm._v("Start Chat")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticStyle: {
                                  "margin-left": "auto",
                                  "font-weight": "bolder",
                                  "letter-spacing": "2px",
                                  "font-size": "20px",
                                },
                                on: {
                                  click: function (e) {
                                    return e.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                ...\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "visitor-actions",
                        staticStyle: {
                          display: "none",
                          "justify-content": "center",
                          "align-items": "center",
                        },
                      },
                      [
                        _vm.checkPermission(
                          _vm.PERMISSION_TYPES["visitor.delete"].tr.name
                        )
                          ? _c(
                              "a-button",
                              {
                                staticClass: "classic-button",
                                staticStyle: { "margin-right": "3px" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    _vm.deleteUserVisible = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "close-circle-o" },
                                    }),
                                    _vm._v(" Delete User"),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.visitorBanned &&
                        _vm.checkPermission(
                          _vm.PERMISSION_TYPES["visitor.block"].tr.name
                        )
                          ? _c(
                              "a-button",
                              {
                                staticClass: "classic-button",
                                staticStyle: { "margin-right": "3px" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.ban()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "stop-o" },
                                    }),
                                    _vm._v(" Block"),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm.checkPermission(
                              _vm.PERMISSION_TYPES["visitor.unblock"].tr.name
                            )
                          ? _c(
                              "a-button",
                              {
                                staticClass: "classic-button",
                                staticStyle: { "margin-right": "3px" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.unban()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "stop-o" },
                                    }),
                                    _vm._v(
                                      " UnBlock\n                                "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "classic-button",
                            staticStyle: { "margin-right": "3px" },
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                _vm.newEventModalVisible = true
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-right": "3px",
                                  display: "block",
                                  "font-size": "12px",
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticClass: "px-1",
                                  attrs: { type: "plus-o" },
                                }),
                                _vm._v(
                                  " Create Event\n                                "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isWABusiness()
                          ? _c(
                              "a-button",
                              {
                                staticClass: "classic-button",
                                staticStyle: { "margin-right": "3px" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.startWhatsappChat()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "play-circle" },
                                    }),
                                    _vm._v(" Start Chat"),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isWhatsappV1()
                          ? _c(
                              "a-button",
                              {
                                staticClass: "classic-button",
                                staticStyle: { "margin-right": "3px" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.startWhatsappChat()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "play-circle" },
                                    }),
                                    _vm._v(" Start Chat"),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isWhatsappV2()
                          ? _c(
                              "a-button",
                              {
                                staticClass: "classic-button",
                                staticStyle: { "margin-right": "3px" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.startWhatsappChat()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "play-circle" },
                                    }),
                                    _vm._v(" Start Chat"),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "classic-button",
                            staticStyle: { "margin-right": "3px" },
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.createTask()
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-right": "3px",
                                  display: "block",
                                  "font-size": "12px",
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticClass: "px-1",
                                  attrs: { type: "plus-o" },
                                }),
                                _vm._v(
                                  " Create Task\n                                "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "user-email",
                    staticStyle: { display: "flex", "align-items": "center" },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.visitor.email
                              ? _vm.visitor.email
                              : _vm.$t("visitor.noEmail")
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    !!_vm.visitor.emailVerified
                      ? _c(
                          "span",
                          { staticClass: "material-icons mail-check" },
                          [_vm._v("verified_user")]
                        )
                      : _c("span", { staticClass: "mail-close" }, [
                          _vm._v("(not verified)"),
                        ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-body" }, [
            _c("div", { staticClass: "supsis-tab-selection" }, [
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-details" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-details")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.profile")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-notes" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-notes")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.notes")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-activities" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-activities")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("wp.actions")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-chats" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-chats")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.conversationHistory")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-mails" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-mails")
                    },
                  },
                },
                [_vm._v("\n                    Mailler\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-tasks" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-tasks")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    Atanan Görevler\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "supsis-tab-selection-item",
                  class: [_vm.tabKey == "visitor-events" && "selected"],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-events")
                    },
                  },
                },
                [_vm._v("\n                    Etkinlikler\n                ")]
              ),
            ]),
            _vm._v(" "),
            _vm.tabKey == "visitor-details"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "mt-4", staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "segments" }, [
                        _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v(" group ")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "segment-user" }, [
                          _vm._v(" Tercih Edilen Temsilciler "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row ml-sm-n1" },
                        [
                          _vm.visitor
                            ? _c("PreferredAgents", {
                                attrs: { visitorId: _vm.cloneVisitorId },
                                model: {
                                  value: _vm.visitor.preferredAgents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.visitor,
                                      "preferredAgents",
                                      $$v
                                    )
                                  },
                                  expression: "visitor.preferredAgents",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-4", staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "segments" }, [
                        _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v(" pie_chart ")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "segment-user" }, [
                          _vm._v(" " + _vm._s(_vm.$t("visitor.tags")) + " "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row ml-sm-n1" },
                        [
                          _vm._l(
                            _vm.selectedTagsList,
                            function (selectTag, index) {
                              return _c(
                                "span",
                                { staticClass: "select-segment" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons closeIcon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.tagRemove(
                                            selectTag._id,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                close\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "select-segment-text" },
                                    [_vm._v(_vm._s(selectTag.name))]
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-segment",
                                  on: {
                                    click: function ($event) {
                                      _vm.tagModalVisible = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: { "font-size": "25px" },
                                    },
                                    [_vm._v("add")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "last-session-data" },
                                    [_vm._v(_vm._s(_vm.$t("visitor.addTag")))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-4", staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "segments" }, [
                        _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v(" pie_chart ")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "segment-user" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("visitor.segments")) + " "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row ml-sm-n1" },
                        [
                          _vm._l(
                            _vm.selectedSegmentsList,
                            function (selectSegment, index) {
                              return _c(
                                "span",
                                { staticClass: "select-segment" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons closeIcon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.segmentRemove(
                                            selectSegment._id,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                close\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "select-segment-text" },
                                    [_vm._v(_vm._s(selectSegment.name))]
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-segment",
                                  on: {
                                    click: function ($event) {
                                      _vm.segmentModalVisible = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: { "font-size": "25px" },
                                    },
                                    [_vm._v("add")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "last-session-data" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("visitor.addSegment"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("VisitorAttributes", {
                        attrs: { visitor: _vm.visitor },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-notes"
              ? _c("div", [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", "margin-top": "40px" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "segments",
                          staticStyle: { "justify-content": "space-between" },
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "20px" },
                              },
                              [_vm._v(" query_builder ")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "segment-user" }, [
                              _vm._v(" Notes "),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("VisitorNotes", { attrs: { notes: _vm.notes } }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-activities"
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", "margin-top": "40px" } },
                    [
                      _c("div", { staticClass: "user-data" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" account_circle "),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "segment-user" }, [
                          _vm._v("Ziyaretçi Haraketleri "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("VisitorActivities", {
                        attrs: { "visitor-id": _vm.cloneVisitorId },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-chats"
              ? _c("div", [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", "margin-top": "40px" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "segments",
                          staticStyle: { "justify-content": "space-between" },
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "20px" },
                              },
                              [_vm._v(" query_builder ")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "segment-user" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("visitor.userChats")) + " "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-segment",
                                  on: { click: _vm.seeAll },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        "font-size": "18px",
                                        "margin-right": "5px",
                                      },
                                    },
                                    [_vm._v("visibility")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "last-session-data" },
                                    [_vm._v(_vm._s(_vm.$t("visitor.seeAll")))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("VisitorChatList", {
                        attrs: { "visitor-id": _vm.cloneVisitorId },
                        on: { detailClose: _vm.closeModal },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-mails"
              ? _c("div", [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", "margin-top": "10px" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "segments",
                          staticStyle: { "justify-content": "space-between" },
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "20px" },
                              },
                              [_vm._v(" query_builder ")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "segment-user" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("visitor.userMails")) + " "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("VisitorMailList", {
                        attrs: {
                          visitorMail: _vm.visitor.email,
                          isGetChat: _vm.visibleMail,
                          visitorId: _vm.cloneVisitorId,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-tasks"
              ? _c(
                  "div",
                  [
                    _c("KanbanList", {
                      attrs: { visitorId: _vm.cloneVisitorId },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-events"
              ? _c(
                  "div",
                  [
                    _c("VisitorEventList", {
                      attrs: {
                        visitorId: _vm.cloneVisitorId,
                        newEvent: _vm.newEvent,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.segmentModalVisible
            ? _c(
                "a-modal",
                {
                  attrs: {
                    id: "add-to-segment",
                    title: _vm.$t("visitor.addSegment"),
                    footer: null,
                  },
                  model: {
                    value: _vm.segmentModalVisible,
                    callback: function ($$v) {
                      _vm.segmentModalVisible = $$v
                    },
                    expression: "segmentModalVisible",
                  },
                },
                [
                  _c("div", { staticClass: "add-segment-search" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.segmentSearch,
                          expression: "segmentSearch",
                        },
                      ],
                      staticStyle: { border: "none" },
                      attrs: { placeholder: _vm.$t("visitor.filterName") },
                      domProps: { value: _vm.segmentSearch },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.segmentSearch = $event.target.value
                          },
                          _vm.segmentSearchChange,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "material-icons mx-2 add-segment-search-icon",
                      },
                      [_vm._v(" search ")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.filterSegments, function (filterSegment) {
                    return _c("VisitorAddSegment", {
                      key: filterSegment._id,
                      attrs: {
                        row: filterSegment,
                        "on-select-changed": function () {
                          return _vm.segmentSelectChanged(filterSegment)
                        },
                        selectedSegments: _vm.selectedSegmentsList,
                      },
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "margin-top": "30px",
                      },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "add-segment-setting-btn",
                          on: {
                            click: function () {
                              return this$1.$router.push(
                                "/chatbot/user-segments"
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons mr-2",
                              staticStyle: { "font-size": "20px" },
                            },
                            [_vm._v(" settings ")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("visitor.manageSegments"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "add-segment-confirm-btn",
                          on: { click: _vm.segmentHandleCancel },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("visitor.confirm")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tagModalVisible
            ? _c(
                "a-modal",
                {
                  attrs: {
                    id: "add-to-tag",
                    title: _vm.$t("visitor.addTag"),
                    footer: null,
                  },
                  model: {
                    value: _vm.tagModalVisible,
                    callback: function ($$v) {
                      _vm.tagModalVisible = $$v
                    },
                    expression: "tagModalVisible",
                  },
                },
                [
                  _c("div", { staticClass: "add-segment-search" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tagSearch,
                          expression: "tagSearch",
                        },
                      ],
                      staticStyle: { border: "none" },
                      attrs: { placeholder: _vm.$t("visitor.filterName") },
                      domProps: { value: _vm.tagSearch },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.tagSearch = $event.target.value
                          },
                          _vm.tagSearchChange,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "material-icons mx-2 add-segment-search-icon",
                      },
                      [_vm._v(" search ")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.getFilteredTags(), function (filterTag) {
                    return _c("VisitorAddSegment", {
                      key: filterTag._id,
                      attrs: {
                        row: filterTag,
                        "on-select-changed": function () {
                          return _vm.tagSelectChanged(filterTag)
                        },
                        selectedSegments: _vm.selectedTagsList,
                      },
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "margin-top": "30px",
                      },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "manage-tags-btn",
                          on: {
                            click: function () {
                              return this$1.$router.push("/tags")
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons mr-2",
                              staticStyle: { "font-size": "20px" },
                            },
                            [_vm._v(" settings ")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("visitor.manageTags"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "add-segment-confirm-btn",
                          on: { click: _vm.tagHandleCancel },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("visitor.confirm")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deleteUserVisible
            ? _c(
                "a-modal",
                {
                  attrs: {
                    id: "delete-user-modal",
                    title: _vm.$t("visitor.deleteUser"),
                    centered: "",
                  },
                  on: {
                    ok: function () {
                      return _vm.deleteUser()
                    },
                  },
                  model: {
                    value: _vm.deleteUserVisible,
                    callback: function ($$v) {
                      _vm.deleteUserVisible = $$v
                    },
                    expression: "deleteUserVisible",
                  },
                },
                [
                  _c("div", { staticClass: "delete-user-modal-message" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.deleteVisitor")) +
                        "\n            "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.newEventModalVisible
            ? _c("CreateEventModal", {
                attrs: { calendarList: _vm.calendarList },
                on: {
                  close: function ($event) {
                    _vm.newEventModalVisible = false
                  },
                  editEvent: function ($event) {
                    return _vm.editEvent($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }